import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

const ADMIN_USERNAME = "admin";
const ADMIN_PASSWORD = "admin123";
const SESSION_KEY = "baptism_admin_token";
const G = "#c9a55a";

export default function BaptismAdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const [showPass, setShowPass] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(SESSION_KEY) === "true") {
      navigate("/baptism/admin", { replace: true });
    }
    if (!document.getElementById("baptism-fonts")) {
      const link = document.createElement("link");
      link.id = "baptism-fonts";
      link.rel = "stylesheet";
      link.href = "https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;1,300;1,400&display=swap";
      document.head.appendChild(link);
    }
  }, []); // eslint-disable-line

  const login = () => {
    if (username.trim().toLowerCase() === ADMIN_USERNAME && password === ADMIN_PASSWORD) {
      localStorage.setItem(SESSION_KEY, "true");
      navigate("/baptism/admin", { replace: true });
    } else {
      setLoginError("Invalid username or password.");
    }
  };

  return (
    <div style={{ background: "linear-gradient(160deg,#0d0d1e,#12122a,#0a0a18)", minHeight: "100vh", fontFamily: "'Cormorant Garamond',Georgia,serif" }}>
      <div style={{ height: 3, background: `linear-gradient(90deg,transparent,${G} 30%,${G} 70%,transparent)` }} />
      <div className="max-w-sm mx-auto px-4 pt-24 pb-10">
        <div className="text-center mb-10">
          <div style={{ fontFamily: "'Playfair Display',serif", color: G }} className="text-4xl font-bold mb-2">⚙</div>
          <h1 style={{ fontFamily: "'Playfair Display',serif", color: "#f1f5f9" }} className="text-3xl font-bold mb-1">Admin Login</h1>
          <p style={{ color: "#6b6b8a" }} className="text-sm">Baptism of Munachimso Zoe Maxwell</p>
        </div>

        <div style={{ background: "rgba(255,255,255,0.04)", border: `1px solid ${G}30` }} className="rounded-3xl p-8 space-y-4">
          <div>
            <label style={{ color: `${G}80`, letterSpacing: "0.1em" }} className="text-xs uppercase block mb-1.5">Username</label>
            <input
              type="text"
              placeholder="Enter username"
              value={username}
              onChange={(e) => { setUsername(e.target.value); setLoginError(""); }}
              onKeyDown={(e) => e.key === "Enter" && login()}
              style={{ borderColor: "rgba(255,255,255,0.15)", background: "rgba(255,255,255,0.06)", color: "#f1f5f9", fontFamily: "'Cormorant Garamond',serif", fontSize: "1rem" }}
              className="w-full border rounded-xl px-4 py-3 focus:outline-none placeholder:text-gray-600 transition-colors"
              onFocus={(e) => (e.target.style.borderColor = G)}
              onBlur={(e) => (e.target.style.borderColor = "rgba(255,255,255,0.15)")}
            />
          </div>

          <div>
            <label style={{ color: `${G}80`, letterSpacing: "0.1em" }} className="text-xs uppercase block mb-1.5">Password</label>
            <div className="relative">
              <input
                type={showPass ? "text" : "password"}
                placeholder="Enter password"
                value={password}
                onChange={(e) => { setPassword(e.target.value); setLoginError(""); }}
                onKeyDown={(e) => e.key === "Enter" && login()}
                style={{ borderColor: "rgba(255,255,255,0.15)", background: "rgba(255,255,255,0.06)", color: "#f1f5f9", fontFamily: "'Cormorant Garamond',serif", fontSize: "1rem" }}
                className="w-full border rounded-xl px-4 py-3 pr-12 focus:outline-none placeholder:text-gray-600 transition-colors"
                onFocus={(e) => (e.target.style.borderColor = G)}
                onBlur={(e) => (e.target.style.borderColor = "rgba(255,255,255,0.15)")}
              />
              <button
                type="button"
                onClick={() => setShowPass(!showPass)}
                style={{ color: "#6b6b8a" }}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-sm hover:opacity-70"
              >
                {showPass ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          {loginError && <p className="text-red-400 text-sm text-center">{loginError}</p>}

          <button
            onClick={login}
            style={{ background: `linear-gradient(135deg,#c9a55a,#a07838)`, fontFamily: "'Cormorant Garamond',serif", letterSpacing: "0.2em" }}
            className="w-full text-white font-semibold py-4 rounded-xl uppercase text-sm hover:opacity-90 active:opacity-75 transition-opacity shadow-lg mt-2"
          >
            Login
          </button>
        </div>

        <div className="text-center mt-8">
          <Link to="/baptism" style={{ color: `${G}50` }} className="text-xs hover:opacity-70 transition-opacity">
            ← Back to Invite
          </Link>
        </div>
      </div>
      <div style={{ height: 3, background: `linear-gradient(90deg,transparent,${G} 30%,${G} 70%,transparent)` }} />
    </div>
  );
}
